const JAPANESE_LANGUAGE_TYPE = 'JP'
const DOUBLE_PACK_LANGUAGE_TYPE = 'ENJP'

const parseLanguageInfo = (languageInfo: string | null | undefined): Set<string> => {
  if (!languageInfo) {
    return new Set()
  }

  return new Set(
    languageInfo
      .split(',')
      .map((language) => language.trim())
      .filter(Boolean),
  )
}

const hasJapaneseOrDoublePack = (languageInfo: string | null | undefined): boolean => {
  const languages = parseLanguageInfo(languageInfo)

  return languages.has(JAPANESE_LANGUAGE_TYPE) || languages.has(DOUBLE_PACK_LANGUAGE_TYPE)
}

type HexagonGmiBannerEligibilityParams = {
  trialClassCompYn: string
  paymentYn: string
  trialClassCompInfo: string | null
  paymentInfo: string | null
  welcomeBackPromotionEligible: boolean
}

export const shouldShowHexagonGmiBanner = ({
  trialClassCompYn,
  paymentYn,
  trialClassCompInfo,
  paymentInfo,
  welcomeBackPromotionEligible,
}: HexagonGmiBannerEligibilityParams): boolean => {
  const completedJapaneseTrial = trialClassCompYn === 'Y' && hasJapaneseOrDoublePack(trialClassCompInfo)
  const hasJapaneseOrDoublePackPaidHistory = hasJapaneseOrDoublePack(paymentInfo)
  const hasActiveJapaneseOrDoublePackPayment = paymentYn === 'Y' && hasJapaneseOrDoublePackPaidHistory
  const hasWelcomeBackEligibleJapaneseOrDoublePackHistory =
    welcomeBackPromotionEligible && hasJapaneseOrDoublePackPaidHistory

  return (
    completedJapaneseTrial || hasActiveJapaneseOrDoublePackPayment || hasWelcomeBackEligibleJapaneseOrDoublePackHistory
  )
}
